import DutyTable from './component'

export default DutyTable
